"use client";

//import { cookies } from 'next/headers'
import React, { useState } from 'react';

export default function PasswordPromptDialog({ codes, slug }:{
    codes: Array<string>,
    slug: string
}) {

    const [password, setPassword] = useState('');
    const [passwordIncorrect, setPasswordIncorrect] = useState(false)
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        if (codes.includes(password)) {
            await fetch(`/api/cookie_set`, {
                body: JSON.stringify({slug}),
                method: "post",
            });
            window.location.reload();
        } else {
            return setPasswordIncorrect(true), setLoading(false);
        }
    };

    return (
        <div className="relative top-[64px] flex-grow lg:top-0">
            <div className="mx-auto">
                <div className="max-w-auto mx-auto lg:max-w-container mt-10 mb-10">
                    <div className="password-prompt-dialog">
                        <h1 className="relative mg-[15px] mt-10 lg:mb-[25px] text-[45px] lg:text-[65px] leading-[45px] lg:leading-[60px] font-AgencyFBBlackComp antialiased  uppercase text-neutral-900 tracking-wide antialiased">Cette page est protégée</h1>
                        <p className="mb-4 mt-4 leading-10 text-xl lg:text-2xl">
                            Veuillez entrer le code qui vous a été fourni pour accéder à cette page.
                        </p>
                        {passwordIncorrect && (
                            <div className="error-message text-red-500 mb-4">
                                Votre code est incorrect.
                            </div>
                        )}
                        <form onSubmit={handleSubmit} className="mb-4">
                            <label htmlFor="password">Code : </label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className='border border-gray-300 rounded-md p-2 mb-4'
                            />
                            <br />
                            <button type="submit" className="border border-gray-300 rounded-md p-2">Valider</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}